import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer, useEffect, } from 'react';
import { cleanShortcuts } from './utils/cleanShortcuts';
import { combineShortcuts } from './utils/combineShortcuts';
import { getKeyDownHandler, useLastTriggerRef, } from './utils/getKeyDownHandler';
const initialKbsState = {
    inputShortcuts: [],
    cleanedShortcuts: [],
    combinedShortcuts: {},
    disableCount: 0,
};
export const kbsContext = createContext(initialKbsState);
const kbsDispatchContext = createContext(null);
export function useKbsUncheckedDispatch() {
    return useContext(kbsDispatchContext);
}
export function useKbsDispatch() {
    const dispatch = useContext(kbsDispatchContext);
    if (!dispatch) {
        throw new Error('missing context');
    }
    return dispatch;
}
function kbsReducer(state, action) {
    switch (action.type) {
        case 'INIT': {
            const newInputs = [...state.inputShortcuts, action.shortcuts];
            const cleanedShortcuts = cleanShortcuts(newInputs);
            return {
                ...state,
                inputShortcuts: newInputs,
                cleanedShortcuts,
                combinedShortcuts: combineShortcuts(cleanedShortcuts),
            };
        }
        case 'CLEANUP': {
            const newInputs = state.inputShortcuts.filter((shortcuts) => shortcuts !== action.shortcuts);
            const cleanedShortcuts = cleanShortcuts(newInputs);
            return {
                ...state,
                inputShortcuts: newInputs,
                cleanedShortcuts,
                combinedShortcuts: combineShortcuts(cleanedShortcuts),
            };
        }
        case 'DISABLE_GLOBAL': {
            return { ...state, disableCount: state.disableCount + 1 };
        }
        case 'ENABLE_GLOBAL': {
            return { ...state, disableCount: state.disableCount - 1 };
        }
        default:
            throw new Error('unreachable');
    }
}
export function KbsProvider(props) {
    const [kbsState, kbsDispatch] = useReducer(kbsReducer, initialKbsState);
    const lastTrigger = useLastTriggerRef();
    useEffect(() => {
        if (kbsState.disableCount !== 0)
            return;
        const handleKeyDown = getKeyDownHandler(lastTrigger, kbsState.combinedShortcuts);
        document.body.addEventListener('keydown', handleKeyDown);
        return () => document.body.removeEventListener('keydown', handleKeyDown);
    }, [kbsState.disableCount, kbsState.combinedShortcuts, lastTrigger]);
    return (_jsx(kbsContext.Provider, { value: kbsState, children: _jsx(kbsDispatchContext.Provider, { value: kbsDispatch, children: props.children }) }));
}
